/* show color based on measured value */

import {interpolateYlOrRd} from 'd3-scale-chromatic'
import * as d3 from '../../scripts/lib/d3.js'
import data from '../../data/datasets.js'

const colorDomain = [0, d3.max(data.map(d => d.mVal))]
const cScale = d3.scaleLinear().range([0, 1]).domain(colorDomain)

export default val => interpolateYlOrRd(cScale(val))



// WEBPACK FOOTER //
// ./src/components/bullet-bar/get_color.js